export function LocalStorageFactory(): any {
    return window.localStorage;
}
export function SessionStorageFactory(): any {
    return window.sessionStorage;
}
